import { request } from './request.js'

export const getBossEbooks = () => request.get('ebook-classes')
export const getBossEbooksById = id => request.get('ebook-classes/' + id)
export const updateEbooksBrowse = (id, data) => request.put(`ebook-classes/${id}/count`, data)
export const getBossArticles = page => request.get('boss-articles?page=' + page)
export const getBossArticlesById = id => request.get('boss-articles/' + id)
